/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Missing_Speaker_LabelInputs */



/**
* | output |
* | --- |
* | "Missing Speaker Assignment" |
*
* @param {Style_Guide_Manager_Missing_Speaker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_missing_speaker_label = /** @type {((inputs?: Style_Guide_Manager_Missing_Speaker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Missing_Speaker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affectation de locuteur manquante")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlende Sprecherzuweisung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnazione dell'oratore mancante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отсутствует назначение спикера")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignación de orador faltante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缺少发言人分配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーの割り当てが不明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता का असाइनमेंट गायब है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuição de palestrante ausente")
	return /** @type {LocalizedString} */ ("Missing Speaker Assignment")
});